import { useEffect } from 'react';

import type { Skill } from 'src/__generated__/graphql';
import {
  Page,
  PageSection,
  PageSectionState,
  UpdateType,
  useTrackingClient,
} from 'src/context/tracking';
import { useGetCurrentPage } from 'src/hooks/useGetCurrentPage';
import { useProfileAnalytic } from 'src/hooks/useProfileAnalytic';

export function useTracking({ skills }: { skills: Skill[] }) {
  const {
    profileApproachabilityStatus,
    profileSharedStatus,
    profileVisibilityLevel,
  } = useProfileAnalytic();
  const client = useTrackingClient();
  const currentPage = useGetCurrentPage();

  useEffect(() => {
    client.trackView({
      view: Page.PROFILE_PAGE,
      actionOrigin: 'steps:applicationForm',
      profileUpdateSource: 'steps',
      eventName: 'profile_section_displayed',
      currentPageSection: PageSection.SKILLS,
      currentPageSectionState:
        skills.length === 0 ? PageSectionState.ADD : PageSectionState.EDIT,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function trackUpdate(values: Skill[]) {
    client.trackLink({
      ...(skills.length > 0
        ? {
            link: 'profile-skills-edit',
            pageTitle: 'profile+skills+edit',
            updateType: UpdateType.EDIT,
          }
        : {
            link: 'profile-skills-add',
            pageTitle: 'profile+skills+add',
            updateType: UpdateType.ADD,
          }),
      eventName: 'profile_update_succeeded',
      skillsStartTotal: skills.length,
      skillsCompleteTotal: values.length,
      actionOrigin: 'steps:applicationForm',
      currentPage,
      currentPageSection: PageSection.SKILLS,
      profileUpdateSource: 'steps',
      profileApproachabilityStatus,
      profileSharedStatus,
      profileVisibilityLevel,
    });
  }

  return { trackUpdate };
}
